import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kn-list-item-text" }
const _hoisted_2 = { class: "kn-list-item-text-secondary" }
const _hoisted_3 = { class: "kn-list-item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.savedVersions')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_Listbox, {
        class: "kn-list",
        options: _ctx.businessModelVersions,
        "data-test": "versions-list"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.noSavedVersions')), 1)
        ]),
        option: _withCtx((slotProps) => [
          _createVNode("div", {
            class: "kn-list-item",
            "data-test": 'version-' + slotProps.option.id
          }, [
            _createVNode(_component_RadioButton, {
              name: "active",
              value: slotProps.option,
              modelValue: _ctx.activeVersion,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeVersion = $event)),
              disabled: _ctx.readonly,
              onChange: _ctx.setActive
            }, null, 8, ["value", "modelValue", "disabled", "onChange"]),
            _createVNode("div", _hoisted_1, [
              _createVNode("span", null, _toDisplayString(slotProps.option.fileName), 1),
              _createVNode("span", _hoisted_2, _toDisplayString(_ctx.creationDate(slotProps.option.creationDate)), 1)
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode("span", null, _toDisplayString(slotProps.option.creationUser), 1)
            ]),
            _createVNode(_component_Button, {
              class: "p-button-link p-button-sm",
              icon: "fa fa-ellipsis-v",
              onClick: ($event: any) => (_ctx.toggle($event, slotProps.option)),
              "aria-haspopup": "true",
              "aria-controls": "overlay_menu"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Menu, {
              ref: "menu",
              model: _ctx.items,
              popup: true
            }, null, 8, ["model"])
          ], 8, ["data-test"])
        ]),
        _: 1
      }, 8, ["options"])
    ]),
    _: 1
  }))
}